import { useEffect } from 'react'
import CardButton from 'components/CardButtons'
import { trackEvent } from 'analytics/trackFunctions'
import { useNavigate } from 'react-router-dom'
import ModalContainer from './ModalContainer'
import RoundedIcon from './RoundedIcon'

import thinkingEmoji from '../assets/images/emojis/thinking-emoji.png'
import Thunderbolt from '../assets/images/emojis/thunderbolt.png'

const HubInformationModal = ({
  canTakeAdvance,
  isOpen,
  setIsOpen,
  expirationDate
}) => {
  const navigate = useNavigate()

  useEffect(() => {
    if (canTakeAdvance) {
      trackEvent({ eventName: 'bille_popup_lineacredito' })
    } else {
      trackEvent({ eventName: 'bille_popup_prestamo' })
    }
  }, [])

  return (
    <ModalContainer isShown={isOpen} setModalFunction={setIsOpen}>
      <div className='flex flex-col items-center text-center text-black text-2xs leading-4 mb-8'>
        <RoundedIcon icon={<img src={thinkingEmoji} alt='🤔' />} />
        <h3 className='font-bold text-2xl leading-6 my-5'>
          ¿Por qué se encuentra deshabilitada esta opción?
        </h3>
        {canTakeAdvance ? (
          <>
            <p>
              En Wayni, por cuestiones de seguridad y normativas de la empresa,
              podemos brindarte un único préstamo.
            </p>
            <p className='font-bold mt-6'>Pero no todo son malas noticias...</p>
            <p>Podés solicitar tu Adelanto en una sola cuota.</p>

            <div className='px-3 mt-7'>
              <CardButton
                icon={Thunderbolt}
                title='Adelantos en tu tarjeta'
                description='Hace click para tener tu beneficio'
                onClick={() => {
                  trackEvent({ eventName: 'bille_popup_prestamo_adelantos' })
                  navigate('/wayni-credito')
                }}
                classNameCard='bg-[#F3F3F3]'
              />
            </div>
          </>
        ) : (
          <p className='text-2xs'>
            Te quedaste sin línea de crédito disponible, el {expirationDate} se
            renovará y podrás solicitar nuevos préstamos y adelantos.
          </p>
        )}
      </div>
    </ModalContainer>
  )
}

export default HubInformationModal
